import React from "react";
import { Col, Row, Table } from "react-bootstrap";

function SrcBank() {
  return (
    <div>
      <Row>
        <h1>JSGIF South Region Bank Account Details</h1>
      </Row>
      <Table responsive="md" striped bordered>
        <tbody className="tableBody">
          <tr>
            <td style={{ fontWeight: "800" }}>Name</td>
            <td style={{ fontWeight: "600" }}>JSGIF SOUTH REGION</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "800" }}>Bank Name</td>
            <td style={{ fontWeight: "600" }}>Punjab National Bank</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "800" }}>Branch Name</td>
            <td style={{ fontWeight: "600" }}>Anna Salai</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "800" }}>Account Number</td>
            <td style={{ fontWeight: "600" }}>0306 000 100 648 165</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "800" }}>IFS Code</td>
            <td style={{ fontWeight: "600" }}>PUNB 003 0600</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}

export default SrcBank;
